// keys for google recaptcha service
const captchaConfig = {
  siteKey: '6LcYyvMZAAAAAK2nxxGwbsgquoe7OS0188RBP9BO',
  secretKey: '6LcYyvMZAAAAANUzSXu_By7y6k2f0aeehVymKuCG',
};
export default captchaConfig;